import { Page } from "./page";

export class Question extends Page
{
}
